import { keyBy } from 'lodash-es';

import { StudyLibraryClient } from 'jf/api';
import { useClientQuery } from 'jf/utils/useClientQuery';

export const useSelectPrompt = (props: { promptSlug: string }) => {
  const { data: prompts } = useClientQuery(StudyLibraryClient.getPrompts);

  const promptsBySlug = keyBy(prompts, 'slug');
  const prompt = promptsBySlug[props.promptSlug];
  return prompt;
};
